module.exports = __webpack_public_path__ + "img/jzy_problem_02.fc2b8c5e.png";